import styled from 'styled-components';

export const Toast = styled.div`
  position: fixed;
  z-index: 70;
  top: calc(env(safe-area-inset-top) + 10px);
  left: 12px;
  right: 12px;
  max-width: 480px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 10px 10px 16px;
  border-radius: 14px;
  background: #4a1510;
  box-shadow: 0 10px 30px rgba(0, 0, 0, .5);

  & > div {
    flex: 1;
  }

  & p {
    margin: 0;
  }
`;

export const Detail = styled.small`
  display: block;
  color: #ffb3aa;
`;
